export const getAccessToken = async () => {
  const {$propelAuth} = useNuxtApp();
  if (!$propelAuth) return false; // If the plugin isn't loaded, don't do anything (happens server side — which doesn't matter)
  const auth = await $propelAuth.getAuthenticationInfoOrNull();
  if (!auth) return false; // If the user isn't logged in, do nothing
  const {getActiveOrg} = await useActiveOrg();
  const activeOrg = getActiveOrg();
  const {accessToken} = await $propelAuth.getAccessTokenForOrg(activeOrg); // You could use auth.accessToken, but if the user is part of too many orgs, you'll run into a 431 Headers Too Big. This grabs only the activeOrg token.
  return {accessToken, activeOrg};
};
